import Logo from "./logo.png";
import ShutterbLogo from "./shutterb-logo.png";
import Avatar from "./avatar.jpg";
import RecapImage from "./recap.png";
import CheckIn from "./check-in.png";
import CheckOut from "./check-out.png";
import Tip from "./customer-icon-tip.png";
import Reel from "./customer-icon-reel.png";
import Clock from "./customer-icon-clock.png";
import EventDetails from "./event-details.png";
import Review from "./customer-icon-review.png";
import Message from "./message-enabled-icon.png";
import Gallery from "./customer-icon-gallery.png";
import Invoice from "./customer-icon-invoice.png";
import CancelEvent from "./cancel-event-icon.png";
import CheckInDisabled from "./check-in-disabled.png";
import EditEvent from "./customer-icon-edit-event.png";
import CheckOutDisabled from "./check-out-disabled.png";
import MessageDisabled from "./message-disabled-icon.png";
import ReelDisabled from "./customer-icon-reel-disabled.png";
import CancelEventDisabled from "./cancel-event-disabled-icon.png";
import GalleryDisabled from "./customer-icon-gallery-disabled.png";
import TickMark from "./tick-mark.png";
import DownloadAssets from "./download-assets.png";
import VideoPosting from "./video-posting.png";
import RecapFeedback from "./recap-feedback.png";
import DownloadAssetsDisabled from "./download-assets-disabled.png";
import TipDisabled from "./customer-icon-tip-disabled.png";
import ClockDisabled from "./customer-icon-clock-disabled.png";
import EditEventDisabled from "./customer-icon-edit-event-disabled.png";
import InvoiceDisabled from "./customer-icon-invoice-disabled.png";
import ReviewDisabled from "./customer-icon-review-disabled.png";

export const Images = {
  Tip,
  Logo,
  Reel,
  Clock,
  Review,
  Avatar,
  CheckIn,
  Invoice,
  Message,
  Gallery,
  CheckOut,
  TickMark,
  EditEvent,
  RecapImage,
  CancelEvent,
  ReelDisabled,
  EventDetails,
  VideoPosting,
  DownloadAssets,
  GalleryDisabled,
  MessageDisabled,
  CheckInDisabled,
  CheckOutDisabled,
  CancelEventDisabled,
  RecapFeedback,
  DownloadAssetsDisabled,
  TipDisabled,
  ClockDisabled,
  EditEventDisabled,
  InvoiceDisabled,
  ReviewDisabled,
  ShutterbLogo,
};
